import Carrousel from "./Carrousel";

export default function OurFood() {
  return (
    <div className="flex-1 mt-30">

      <Carrousel />
    </div>
  );
}
